// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./sb-admin-2.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./react-tag-autocomplete.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for dealer */
.dealer {
  /* Panels */ }
  .dealer h1 {
    margin-top: 10px; }
    .dealer h1 .published-state {
      padding-left: 20px; }
  .dealer .dealerMake table {
    table-layout: auto; }
  .dealer .panel .panel-heading a {
    color: #333333; }
    .dealer .panel .panel-heading a:hover, .dealer .panel .panel-heading a:active, .dealer .panel .panel-heading a:focus {
      text-decoration: none; }
    .dealer .panel .panel-heading a:after {
      content: '\\f0d7';
      padding-left: 10px;
      font-family: FontAwesome; }
    .dealer .panel .panel-heading a.open:after {
      content: '\\f0d8'; }

.dealerEmployee .mf-employee-image {
  max-width: 116px;
  width: 100%; }

/* Modal window */
.employeeImageDrop {
  width: 100%;
  border: 2px dashed #ccc;
  height: 100px;
  padding: 10px; }
  .employeeImageDrop.active {
    background-color: #ccc;
    border: 2px dashed #fff; }

.employeeImagePreview {
  display: inline-block; }

/* Styles for car model and variants */
.mf-model h1 {
  margin-top: 10px; }

.mf-model .mf-model-images .mf-model-image {
  display: inline-block;
  margin: 0 10px 10px 0; }

/* MG overrides */
html {
  font-size: 14px; }

body {
  font-family: 'Roboto', sans-serif; }

.navbar .navbar-top-links a, ul.dropdown-menu li a {
  color: white; }

.navbar a {
  color: #1565C0; }

li.dropdown a:hover {
  background-color: #1565C0; }

li.dropdown.open a.dropdown-toggle {
  background-color: #1565C0; }

.navbar-static-top, ul.dropdown-menu {
  background-color: #1565C0; }

.navbar-header img.navbar-brand {
  padding-top: 0px;
  padding-bottom: 0px; }

input[pattern]:invalid {
  color: red;
  border-color: red; }

table.table-nowrap td {
  white-space: nowrap; }

table.table-nowrap td.td-fullwidth {
  width: 100%; }

/* Helpers */
.mf-pre-limit-height {
  max-height: 200px;
  overflow: auto; }

/* Margins */
.mf-margin-bottom-5 {
  margin-bottom: 5px; }

.mf-margin-bottom-10 {
  margin-bottom: 10px; }

.mf-margin-bottom-20 {
  margin-bottom: 20px; }

.mf-margin-right-10 {
  margin-right: 10px; }

.mf-margin-right-20 {
  margin-right: 20px; }

.mf-margin-left-10 {
  margin-left: 10px; }

.mf-margin-left-20 {
  margin-left: 20px; }

.mf-margin-top-10 {
  margin-top: 10px; }

.mf-margin-top-20 {
  margin-top: 20px; }

.mf-margin-top-70 {
  margin-top: 70px; }

.mf-margin-bottom-40 {
  margin-bottom: 40px; }

/* paddings */
.mf-padding-10 {
  padding: 10px; }

.mf-margin-top-5 {
  margin-top: 5px; }

.mf-padding-top-10 {
  padding-top: 10px; }

.mf-padding-right-10 {
  padding-right: 10px; }

.mf-padding-20 {
  padding: 20px; }

.mf-padding-top-20 {
  padding-top: 20px; }

.mf-padding-right-20 {
  padding-right: 20px; }

.clearboth {
  clear: both; }

/* Bootstrap overrides */
.nav-tabs.panel-tabs {
  border-bottom: 0; }

.nav-tabs > li.active > a {
  background-color: #f8f8f8; }
  .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
    background-color: #f8f8f8; }

#page-wrapper {
  padding-top: 0.1px;
  padding-bottom: 0.1px; }

.tab-pane {
  padding: 20px 20px;
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-top: none; }

.page-header {
  margin: 20px 0; }
  .page-header > h1 {
    margin-bottom: 0; }

.form-group textarea.form-control {
  min-width: 100%;
  max-width: 100%;
  min-height: 40px; }

@media (min-width: 1600px) {
  .col-xl-1 {
    width: 8.333333%; }
  .col-xl-2 {
    width: 20%; }
  .col-xl-3 {
    width: 25%; } }
`, "",{"version":3,"sources":["webpack://./src/components/no/motorgruppen/_dealer.scss","webpack://./src/components/no/motorgruppen/_model.scss","webpack://./src/components/no/motorgruppen/main.scss"],"names":[],"mappings":"AAAA,sBAAA;AAEA;EAeI,WAAA,EAAY;EAfhB;IAEQ,gBAAgB,EAAA;IAFxB;MAKU,kBAAkB,EAAA;EAL5B;IAWQ,kBAAiB,EAAA;EAXzB;IAmBU,cAAc,EAAA;IAnBxB;MAwBY,qBAAqB,EAAA;IAxBjC;MA2BY,gBAAgB;MAChB,kBAAkB;MAClB,wBAAwB,EAAA;IA7BpC;MAgCY,gBAAgB,EAAA;;AAM5B;EAEQ,gBAAgB;EAChB,WAAW,EAAA;;AAOnB,iBAAA;AACA;EACI,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,aAAa,EAAA;EAJjB;IAOQ,sBAAsB;IACtB,uBAAuB,EAAA;;AAG/B;EACI,qBAAqB,EAAA;;AC/DzB,sCAAA;AACA;EAEQ,gBAAgB,EAAA;;AAFxB;EAOY,qBAAqB;EACrB,qBAAqB,EAAA;;ACFjC,iBAAA;AACA;EACE,eAAe,EAAA;;AAEjB;EACE,iCAAiC,EAAA;;AAEnC;EACE,YAAY,EAAA;;AAEd;EACE,cAAc,EAAA;;AAGhB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAE3B;EACE,gBAAgB;EAChB,mBAAmB,EAAA;;AAErB;EACE,UAAU;EACV,iBAAiB,EAAA;;AAGnB;EAEI,mBAAmB,EAAA;;AAFvB;EAKI,WAAW,EAAA;;AAIf,YAAA;AACA;EACE,iBAAiB;EACjB,cAAc,EAAA;;AAGhB,YAAA;AACA;EACE,kBAAkB,EAAA;;AAEpB;EACI,mBAAmB,EAAA;;AAEvB;EACI,mBAAmB,EAAA;;AAEvB;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAEtB;EACI,iBAAiB,EAAA;;AAErB;EACI,iBAAiB,EAAA;;AAErB;EACI,gBAAgB,EAAA;;AAEpB;EACI,gBAAgB,EAAA;;AAEpB;EACI,gBAAgB,EAAA;;AAEpB;EACI,mBAAmB,EAAA;;AAGvB,aAAA;AACA;EACE,aAAa,EAAA;;AAEf;EACE,eAAe,EAAA;;AAEjB;EACE,iBAAiB,EAAA;;AAEnB;EACE,mBAAmB,EAAA;;AAErB;EACE,aAAa,EAAA;;AAEf;EACE,iBAAiB,EAAA;;AAEnB;EACE,mBAAmB,EAAA;;AAGrB;EACE,WAAW,EAAA;;AAGb,wBAAA;AACA;EACE,gBAAgB,EAAA;;AAElB;EACE,yBAAyB,EAAA;EAD3B;IAKI,yBAAyB,EAAA;;AAI7B;EAEE,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB,EAAA;;AAElB;EACE,cAAc,EAAA;EADhB;IAII,gBAAgB,EAAA;;AAKpB;EAEI,eAAe;EACf,eAAe;EACf,gBAAgB,EAAA;;AAKpB;EACE;IACE,gBAAgB,EAAA;EAElB;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA,EACX","sourcesContent":["/* Styles for dealer */\n\n.dealer {\n    h1 {\n        margin-top: 10px;\n\n        .published-state {\n          padding-left: 20px;\n        }\n    }\n\n    .dealerMake {\n      table {\n        table-layout:auto;\n      }\n    }\n\n    /* Panels */\n    .panel {\n      .panel-heading {\n        a {\n          color: #333333;\n\n          &:hover,\n          &:active,\n          &:focus {\n            text-decoration: none;\n          }\n          &:after {\n            content: '\\f0d7';\n            padding-left: 10px;\n            font-family: FontAwesome;\n          }\n          &.open:after {\n            content: '\\f0d8';\n          }\n        }\n      }\n    }\n}\n.dealerEmployee{\n    .mf-employee-image {\n        max-width: 116px;\n        width: 100%;\n    }\n}\n\n.dealerEmployeeEdit {\n}\n\n/* Modal window */\n.employeeImageDrop {\n    width: 100%;\n    border: 2px dashed #ccc;\n    height: 100px;\n    padding: 10px;\n\n    &.active {\n        background-color: #ccc;\n        border: 2px dashed #fff;\n    }\n}\n.employeeImagePreview {\n    display: inline-block;\n}\n","/* Styles for car model and variants */\n.mf-model {\n    h1 {\n        margin-top: 10px;\n    }\n\n    .mf-model-images {\n        .mf-model-image {\n            display: inline-block;\n            margin: 0 10px 10px 0;\n        }\n    }\n}\n","@import url('sb-admin-2.min.css');\n@import url('react-tag-autocomplete.css');\n@import \"dealer\";\n@import \"model\";\n\n@import url('https://fonts.googleapis.com/css?family=Roboto');\n\n/* MG overrides */\nhtml {\n  font-size: 14px;\n}\nbody {\n  font-family: 'Roboto', sans-serif;\n}\n.navbar .navbar-top-links a, ul.dropdown-menu li a {\n  color: white;\n}\n.navbar a {\n  color: #1565C0;\n}\n\nli.dropdown a:hover {\n  background-color: #1565C0;\n}\n\nli.dropdown.open a.dropdown-toggle,  {\n  background-color: #1565C0;\n}\n\n.navbar-static-top, ul.dropdown-menu {\n  background-color: #1565C0;\n}\n.navbar-header img.navbar-brand {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\ninput[pattern]:invalid{\n  color: red;\n  border-color: red;\n}\n\ntable.table-nowrap {\n  td {\n    white-space: nowrap;\n  }\n  td.td-fullwidth {\n    width: 100%;\n  }\n}\n\n/* Helpers */\n.mf-pre-limit-height {\n  max-height: 200px;\n  overflow: auto;\n}\n\n/* Margins */\n.mf-margin-bottom-5 {\n  margin-bottom: 5px;\n}\n.mf-margin-bottom-10 {\n    margin-bottom: 10px;\n}\n.mf-margin-bottom-20 {\n    margin-bottom: 20px;\n}\n.mf-margin-right-10 {\n    margin-right: 10px;\n}\n.mf-margin-right-20 {\n    margin-right: 20px;\n}\n.mf-margin-left-10 {\n    margin-left: 10px;\n}\n.mf-margin-left-20 {\n    margin-left: 20px;\n}\n.mf-margin-top-10 {\n    margin-top: 10px;\n}\n.mf-margin-top-20 {\n    margin-top: 20px;\n}\n.mf-margin-top-70 {\n    margin-top: 70px;\n}\n.mf-margin-bottom-40 {\n    margin-bottom: 40px;\n}\n\n/* paddings */\n.mf-padding-10 {\n  padding: 10px;\n}\n.mf-margin-top-5 {\n  margin-top: 5px;\n}\n.mf-padding-top-10 {\n  padding-top: 10px;\n}\n.mf-padding-right-10 {\n  padding-right: 10px;\n}\n.mf-padding-20 {\n  padding: 20px;\n}\n.mf-padding-top-20 {\n  padding-top: 20px;\n}\n.mf-padding-right-20 {\n  padding-right: 20px;\n}\n\n.clearboth {\n  clear: both;\n}\n\n/* Bootstrap overrides */\n.nav-tabs.panel-tabs {\n  border-bottom: 0;\n}\n.nav-tabs > li.active > a {\n  background-color: #f8f8f8;\n\n  &:hover,\n  &:focus {\n    background-color: #f8f8f8;\n  }\n}\n\n#page-wrapper {\n  // Prevent margin collapse:\n  padding-top: 0.1px;\n  padding-bottom: 0.1px;\n}\n\n.tab-pane {\n  padding: 20px 20px;\n  background: #f8f8f8;\n  border: 1px solid #ddd;\n  border-top: none;\n}\n.page-header {\n  margin: 20px 0;\n\n  > h1 {\n    margin-bottom: 0;\n  }\n}\n\n\n.form-group {\n  textarea.form-control {\n    min-width: 100%;\n    max-width: 100%;\n    min-height: 40px;\n  }\n}\n\n\n@media (min-width:1600px) {\n  .col-xl-1 {\n    width: 8.333333%;\n  }\n  .col-xl-2 {\n    width: 20%;\n  }\n  .col-xl-3 {\n    width: 25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
